import { Component,  Input, OnInit } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { Program} from 'globals/store/programs.data';
import { removeUniqueStringFromList } from '../../helpers/helpers';
import { TagPanelData, TagType } from 'globals/store/tags.data';
import { programTagReselector } from '../../store/reselectors/programs.reselector';
import { TagPanelComponent } from '../manage/tag-panel.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'program-tag-panel',
    template: `
<tag-panel *ngIf="!!program && tagData"
  [readOnly]="readOnly" 
  [tagData]="tagData" 
  (removeTag)="removeTag($event)" 
  (setTags)="setTags($event)"
></tag-panel>
`,
    standalone: true,
    imports: [TagPanelComponent, CommonModule],
})
export class ProgramTagPanelComponent extends Wrapper<ProgramTagPanelComponent> implements OnInit {
  @Input() program: Program
  @Input() readOnly: boolean
  tagData: TagPanelData

  ngOnInit() {
    this.subProp(this.store.select(programTagReselector, this.program.id), 'tagData')
  }

  async saveProgram() {
    await this.programService.upsertProgram(this.program, { function:'saveProgram', data:{program: this.program}}, false)
  }

  setTags({ tagType, ids }: { tagType: TagType, ids: string[] }) {
    switch (tagType) {
      case 'attendee':
        this.program.attendeeTags = ids
        break
      case 'workforce': 
        this.program.workforceTags = ids
        break
      case 'performer':
        this.program.performerTags = ids
        break
      case 'sponsor':
        this.program.sponsorTags = ids
        break
      case 'exhibitor':
        this.program.exhibitorTags = ids
        break
      case 'resource':
        this.program.resourceTags = ids
        break
      default:
        console.log(`Missing case for type: ${tagType}`)
        return
    }
    this.saveProgram()
  }

  removeTag({ tagType, id }: { tagType: TagType, id: string }) {
    switch (tagType) {
      case 'attendee':
        removeUniqueStringFromList(this.program.attendeeTags, id)
        break
      case 'workforce': 
        removeUniqueStringFromList(this.program.workforceTags, id)
        break
      case 'performer':
        removeUniqueStringFromList(this.program.performerTags, id)
        break  
      case 'sponsor':
        removeUniqueStringFromList(this.program.sponsorTags, id)
        break  
      case 'exhibitor':
        removeUniqueStringFromList(this.program.exhibitorTags, id)
        break      
      case 'resource':
        removeUniqueStringFromList(this.program.resourceTags, id)
        break
      default:
        console.log(`Missing case for type: ${tagType}`)
        return
    }
    this.saveProgram()
  }



}



